/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./scene-category.vue?vue&type=template&id=368c5102&scoped=true&"
import script from "./scene-category.vue?vue&type=script&lang=ts&"
export * from "./scene-category.vue?vue&type=script&lang=ts&"
import style0 from "./scene-category.vue?vue&type=style&index=0&id=368c5102&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368c5102",
  null
  
)

export default component.exports